import React from 'react';
import Layout from '../components/layout/Layout';

const PoliciesPage = () => {
    return (
        <Layout>
            <div data-testid="policies-page">
                {/* Hero */}
                <section className="bg-navy text-white py-16">
                    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
                        <h1 className="font-heading text-4xl sm:text-5xl font-bold mb-4">Policies</h1>
                        <p className="text-xl text-gray-300 max-w-2xl mx-auto">
                            Our terms of service and privacy policy
                        </p>
                    </div>
                </section>

                {/* Content */}
                <section className="py-16 bg-gray-50">
                    <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
                        {/* Terms of Service */}
                        <div className="bg-white rounded-lg shadow-sm p-8 mb-8">
                            <h2 className="font-heading text-2xl font-bold text-navy mb-6">Terms of Service</h2>
                            
                            <div className="prose prose-gray max-w-none">
                                <h3 className="text-lg font-semibold text-navy mt-6 mb-3">1. Acceptance of Terms</h3>
                                <p className="text-gray-600 mb-4">
                                    By accessing and using Hotel Motel Club, you accept and agree to be bound by the terms 
                                    and provision of this agreement. If you do not agree to abide by these terms, please 
                                    do not use this service.
                                </p>

                                <h3 className="text-lg font-semibold text-navy mt-6 mb-3">2. User Accounts</h3>
                                <p className="text-gray-600 mb-4">
                                    To post listings, you must create an advertiser account with accurate business and 
                                    contact information. You are responsible for maintaining the confidentiality of your 
                                    account credentials and for all activities under your account.
                                </p>

                                <h3 className="text-lg font-semibold text-navy mt-6 mb-3">3. Listing Guidelines</h3>
                                <p className="text-gray-600 mb-4">
                                    All listings must be relevant to the hotel and hospitality industry. Prohibited 
                                    content includes: illegal items or services, misleading information, spam, 
                                    discriminatory content, and anything violating applicable laws.
                                </p>

                                <h3 className="text-lg font-semibold text-navy mt-6 mb-3">4. Fees and Payment</h3>
                                <p className="text-gray-600 mb-4">
                                    Current promotional pricing: First year free for all advertisers. Standard pricing 
                                    after promo period: Annual membership $300/year, Pay-per-ad $10 per listing (30 days).
                                </p>

                                <h3 className="text-lg font-semibold text-navy mt-6 mb-3">5. Limitation of Liability</h3>
                                <p className="text-gray-600 mb-4">
                                    Hotel Motel Club serves as a platform connecting buyers and sellers. We are not 
                                    responsible for the quality, safety, or legality of items or services listed, 
                                    the truth or accuracy of listings, or the ability of parties to complete transactions.
                                </p>
                            </div>
                        </div>

                        {/* Privacy Policy */}
                        <div className="bg-white rounded-lg shadow-sm p-8">
                            <h2 className="font-heading text-2xl font-bold text-navy mb-6">Privacy Policy</h2>
                            
                            <div className="prose prose-gray max-w-none">
                                <h3 className="text-lg font-semibold text-navy mt-6 mb-3">1. Information We Collect</h3>
                                <p className="text-gray-600 mb-4">
                                    We collect information you provide directly: account registration details, listing 
                                    information, and communications. We also automatically collect usage data including 
                                    pages visited, time spent, and device information.
                                </p>

                                <h3 className="text-lg font-semibold text-navy mt-6 mb-3">2. How We Use Information</h3>
                                <p className="text-gray-600 mb-4">
                                    We use your information to: provide and improve our services, communicate with you 
                                    about your account and listings, send marketing communications (with your consent), 
                                    and ensure platform security.
                                </p>

                                <h3 className="text-lg font-semibold text-navy mt-6 mb-3">3. Information Sharing</h3>
                                <p className="text-gray-600 mb-4">
                                    We do not sell your personal information. We may share information with: service 
                                    providers who assist our operations, law enforcement when required by law, and 
                                    other users as necessary for the marketplace to function.
                                </p>

                                <h3 className="text-lg font-semibold text-navy mt-6 mb-3">4. Data Security</h3>
                                <p className="text-gray-600 mb-4">
                                    We implement appropriate technical and organizational measures to protect your 
                                    personal information against unauthorized access, alteration, disclosure, or destruction.
                                </p>

                                <h3 className="text-lg font-semibold text-navy mt-6 mb-3">5. Your Rights</h3>
                                <p className="text-gray-600 mb-4">
                                    You have the right to: access your personal data, correct inaccurate data, request 
                                    deletion of your data, and opt-out of marketing communications. Contact us at 
                                    privacy@hotelmotelclub.com to exercise these rights.
                                </p>

                                <h3 className="text-lg font-semibold text-navy mt-6 mb-3">6. Contact</h3>
                                <p className="text-gray-600">
                                    For privacy-related inquiries, contact us at privacy@hotelmotelclub.com or write to: 
                                    Hotel Motel Club, 123 Hospitality Lane, Suite 100, Miami, FL 33101.
                                </p>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </Layout>
    );
};

export default PoliciesPage;
